enum AllowedFor {
  Supported = 'Supported',
  SupportedChildren = 'SupportedChildren',
  SupportedAndSupportedChildren = 'SupportedAndSupportedChildren',
  Fund = 'Fund',
}

export default AllowedFor;
